import React from 'react'
import Header from '../header'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import SeurePayment from '../secure-payment'
import { useApp, useLanguage } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import { Boxes, Box, NBoxes } from '../box'
import { Iconfont } from '../../../../components/icon/iconfont'
import PrivacyPart from '../../../components/address-form/privacy-part'

const FooterPrivacy = props =>{
    const language = useLanguage();

    return <div className={classes.FooterPrivacy}>
        <a className={classes.PrivaryItem}>
            <span className={classes.PurchaseIcon}></span>

            <span className={`${classes.PriFont} ${language == "de" ? classes.ForceFeed: ""}`}><FormattedMessage id="purchase_protection" defaultMessage="Purchase Protection" /></span>
        </a>

        <a className={classes.PrivaryItem}>
            <Iconfont className={classes.PriIcon}>&#xe6e4;</Iconfont>

            <span className={`${classes.PriFont} ${language == "de" ? classes.ForceFeed: ""}`}><FormattedMessage id="efficient_logistics" defaultMessage="Efficient Logistics" /></span>
        </a>

        <a className={classes.PrivaryItem}>
            <Iconfont className={classes.PriIcon}>&#xe6e1;</Iconfont>

            <span className={`${classes.PriFont} ${language == "de" ? classes.ForceFeed: ""}`}><FormattedMessage id="customer_service" defaultMessage="Customer Service" /></span>
        </a>

        <a className={classes.PrivaryItem}>
            <Iconfont className={classes.PrivacyIcon}></Iconfont>

            <span className={`${classes.PriFont} ${language == "de" ? classes.ForceFeed: ""}`}><FormattedMessage id="privacy_protection" defaultMessage="Privacy Protection" /></span>
        </a>
    </div>
}


export default props => {
    useStyles(classes)
    const { onBack, children, title, extra, hideSecure, showProt, privacyMsg,hideHeader, privacyPadding = false } = props
    const isApp = useApp()

    return <div className={`${classes.Page} ${isApp? classes.App: ''}`} style={hideHeader ? { paddingTop: 0 } : {}}>
        {
            !isApp&&!hideHeader && <Header onBack={onBack} extra={extra}>
                {title}
            </Header>
        }

        {children}

        {
            !hideSecure &&  <NBoxes className={`${classes.BoxMargin} ${privacyPadding && classes.BoxPadding}`}>
                <Box>
                    {
                        privacyMsg &&
                        <PrivacyPart privacyPic={privacyMsg?.imageUrl} privacyInfo={privacyMsg?.message}/>
                        // :<div className={classes.RemindPrivacy}>
                        //     <FooterPrivacy />
                        //     <SeurePayment className={`${classes.SecurePayment} ${showProt? classes.Center:''}`} />
                        // </div>
                    }
                </Box>
            </NBoxes>
        }

        

        {
            showProt && <div className={classes.SecureContent}>
                <FormattedMessage id="protectAccount" defaultMessage="Your account details are fully protected and will not be revealed to any third party for any reasons."/>
            </div>
        }
    </div>
}